import React from "react";
import { BrandMark, ByPokerLauncher, ThemeToggle } from "../ui/Brand";
import { StatusPill } from "../ui/Status";

/**
 * Full-screen status page (maintenance, club deactivated…). Rendered outside
 * the router, so it only uses router-free kit pieces.
 */
const StatusScreen = ({ badge, badgeTone = "danger", title, children, actions, zIndex = 2147483646 }) => (
  <div
    className="fixed inset-0 flex items-center justify-center p-6 bg-cm-bg text-cm-text overflow-y-auto"
    style={{ zIndex }}
    role="alert"
  >
    <ThemeToggle className="absolute top-4 right-4" />
    <div className="w-full max-w-lg">
      <BrandMark size={72} className="mb-6" />
      {badge && <StatusPill tone={badgeTone}>{badge}</StatusPill>}
      <h1 className="font-display text-3xl sm:text-4xl font-extrabold leading-tight mt-4 mb-3">{title}</h1>
      <div className="text-base text-cm-muted leading-relaxed">{children}</div>
      {actions && <div className="flex flex-wrap gap-3 mt-8 pt-6 border-t border-cm-border">{actions}</div>}
      <div className="mt-10">
        <ByPokerLauncher height={22} />
      </div>
    </div>
  </div>
);

export default StatusScreen;
